import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IProjectUser, IRemoveProjectUsersData, IUpsertProjectUserData } from 'projects/types';

export const getProjectUsers = async (
  requestPayload: { project: number },
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/project/people/users?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IProjectUser>(data.data);
};

export const upsertProjectUser = async (data: IUpsertProjectUserData) =>
  await partfinitiClient.postForm('/project/corporate-user/save', data);

export const removeProjectUsers = async (data: IRemoveProjectUsersData) =>
  await partfinitiClient.postForm('/project/corporate-user/remove', data);
